module.exports = __webpack_public_path__ + "img/Stemness-OVCA_10X_TIP.cc895ade.png";